import React, { useEffect } from 'react';
import { Box, Typography, Container } from '@mui/material';
import AppAppBar from '../../components/layout/AppAppBar';
import coinStackingGif from '../../assets/coin-stacking_20260102111635.gif';

export default function PaymentProcessingPageReject() {

  useEffect(() => {
    // Check if user is from reject flow
    const formName = localStorage.getItem('current_form_name');
    const isRejectFlow = formName && formName.toLowerCase().includes('reject');

    if (!isRejectFlow) {
      console.warn('Unauthorized access to Reject processing page. Redirecting...');
      window.location.href = '/';
      return;
    }

    // Simulate processing time then redirect
    const timer = setTimeout(() => {
      sessionStorage.setItem('payment_processed', 'true');
      window.location.href = '/payment-success-reject';
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>
      {/* Common Navbar */}
      <AppAppBar mode="light" toggleColorMode={() => { }} simpleNavbar={true} transparentMode={true} />

      <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minHeight: 'calc(100vh - 60px)', bgcolor: '#fff', pt: 11 }}>
        <Typography
          variant="h4"
          sx={{
            mb: 4,
            fontWeight: 800,
            fontFamily: 'General-Sans-bold',
            color: '#000',
            position: 'relative',
            display: 'inline-block',
            zIndex: 1
          }}
        >
          Payment Status
          <Box
            sx={{
              position: 'absolute',
              bottom: '6px',
              right: '-5px',
              width: '60%',
              height: '10px',
              bgcolor: '#FFD700',
              borderRadius: '2px',
              zIndex: -1
            }}
          />
        </Typography>

        <Box
          sx={{
            width: '200px',
            height: '200px',
            mb: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src={coinStackingGif}
            alt="Processing"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </Box>

        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: '#757575',
            textAlign: 'center',
            fontFamily: 'SF Pro Display'
          }}
        >
          Processing your payment...
        </Typography>
      </Container>
    </Box>
  );
}
